import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa, getFinanceiroCaixa,
    getFinanceiroAgencia,
    getOperadorEmpresa,
    getPerfisVendedores, getVendedorAgencia, getVendedorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import { getFinanceiroEmpresa } from '../../security/securityContext';

export class MenuBagagem extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Bagagem extras" urlRetorno="/gestao-empresa" />
                <div className="vx-menu-bag">

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-pesquisar-bilhete" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">add</span>
                                </div>
                                <div className="vx-menu-bag-label">Nova bagagem</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getFinanceiroAgencia(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                        getVendedorAgencia(this.props.empresaSelecionada.id),
                        getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-bagagem" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">work</span>
                                </div>
                                <div className="vx-menu-bag-label">Gerenciar bagagem</div>
                            </div>
                        </Link>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <Link to="/painel-configuracao-excesso-bagagem" className="vx-menu-bag-card">
                            <div className="vx-menu-bag-card-inner">
                                <div className="vx-menu-bag-icon">
                                    <span className="material-icons">tune</span>
                                </div>
                                <div className="vx-menu-bag-label">Configuração de excesso de bagagem</div>
                            </div>
                        </Link>
                    </Autorizacao>

                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps)(MenuBagagem));
